<template>
  <div>
    <ts-card>
      <div
        class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
      >
        <small class="ts-text-sm text-warning"
          ><i class="fas fa-exclamation-triangle"></i>
          {{ $t('employeeCardActivator.doyouwanttodeactivetheoldcard') }}</small
        >
        <ts-modal-close-button />
      </div>
    </ts-card>
    <ts-card-wrapper>
      <form>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">{{
                $t('employeeCardActivator.statusReason')
              }}</label>
              <div>
                <input
                  type="text"
                  class="form-control"
                  v-model="model.status_reason"
                  :class="{ 'is-invalid': errors.has('status_reason') }"
                  autofocus
                />
                <div class="invalid-feedback" v-if="errors.has('status_reason')">
                  {{ errors.first('status_reason') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row ts-mt-6">
          <div class="col-sm-12 col-lg-12 col-md-12 text-right">
            <ts-button
              class=" btn-sm"
              @click.prevent="$emit('close')"
              :disabled="saving"
              >{{ $t('no') }}</ts-button
            >
            <ts-button
              color="primary"
              class="ml-2 btn-sm"
              :waiting="saving"
              @click.prevent="submit"
              >{{ $t('yes') }}</ts-button
            >
          </div>
        </div>
      </form>
    </ts-card-wrapper>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'

export default {
  props: ['data', 'create_new_card'],
  name: 'confirm-deactivate-old-card-form',
  data() {
    return {
      model: {
        employee_id: null,
        serial_card: '',
        status_reason: ''
      },
      errors: new Errors(),
      saving: false
    }
  },
  created() {
    this.model.employee_id = this.data.employee_id
    this.model.serial_card = this.data.serial_card
    
  },
  methods: {
    submit() {
      let method = 'store'
      if(this.create_new_card == false)
      {
        method = 'update'
      }
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch('humanResource/cardActivator/' + method, {
          id: this.data.employee_id,
          ...this.model
        })
        .then(response => {
          return this.$store
            .dispatch('humanResource/cardActivator/fetch')
            .then(res => {
              this.saving = false
              this.$toasted.success(response.message)
              this.$emit('close')
              this.$emit('before-close')
              return Promise.resolve(res)
            })
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.saving = false
        })
    }
  }
}
</script>
